import UserAddStep from './UserAddStep';
import { withPopup } from './Utils';

export default withPopup(UserAddStep);
